angular.module( 'acme.view.application.pos.create.pages.forms', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.pos.create.pages.forms.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var posCreatePagesForms = {
        name: 'application.pos.create.pages.forms',
        url: '',
        views: {
          "subview-main": {
            controller: 'PosCreatePagesFormsController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/pos/create/pages/forms/forms.tpl.html'
          }
        },
        data: {
          pageTitle: '    '
        }
      };

    $stateProvider
      .state(posCreatePagesForms);
});
